import $ from 'jquery';
import Highcharts from 'highcharts';
import * as Nested from '../core/nested-property-helpers.js';
import tmpl from '../core/simple-template.js';
import {fixCode, getEconomyFct} from './dsibhighcharts-formatter.js';

function toCSVcomment(comment, bindings) {
   return '#,"' + tmpl(comment, bindings) + '"';
}

function toCSVcomments(comments, bindings) {
   if (Array.isArray(comments)) {
      return Object.values(comments).map(function(comment) {
         return toCSVcomment(comment, bindings);
      }).join('\n') + '\n';
   } else {
      return toCSVcomment(comments, bindings) + '\n';
   }   
}

Highcharts.wrap(Highcharts.Chart.prototype, 'getCSV', function (proceed, useLocalDecimalPoint) {
   var csv = '',
       bindings = $.extend({url: window.location.href}, this.options.csv);
   delete bindings.header;
   delete bindings.footer;
   
   var header = Nested.get(this,'options.csv.header');
   if (header) csv += toCSVcomments(header, bindings);

   var rows = this.getDataRows(),
       csvOptions = this.options.exporting.csv,
       decimalPoint = Highcharts.pick(csvOptions.decimalPoint, csvOptions.itemDelimiter !== ',' && useLocalDecimalPoint ? (1.1).toLocaleString()[1] : '.'),
       // use ';' for direct to Excel
       itemDelimiter = Highcharts.pick(csvOptions.itemDelimiter, decimalPoint === ',' ? ';' : ','),
       // '\n' isn't working with the js csv data extraction
       lineDelimiter = csvOptions.lineDelimiter,
       getEconomy = getEconomyFct({enabled: true}),
       useDictionary = (csvOptions.hasOwnProperty('dictionary')) 
         ? csvOptions.dictionary 
         : (this.options.chart.hasOwnProperty('dictionary') && !this.options.chart.dictionary) 
            ? false 
            : rows[1][0] != getEconomy(rows[1][0]),
       withLabel = false;

   // Transform the rows to CSV
   rows.forEach(function(row, i) {
      var code, val, j = row.length;

      while (j--) {
         val = row[j];

         if (useDictionary && (j == 0 || i == 0) && Highcharts._dsib.economies && typeof val === 'string') {
            if (i == 0 && j == 0) {
               if (val == 'code') {
                  val = '"code"' + itemDelimiter + '"label"';
                  withLabel = true;
               } else {
                  val =  '"' + getEconomy(val) + '"';
               }
            } else if (i != 0 && withLabel) {
               code = fixCode(val);
               val = code + itemDelimiter + '"' + getEconomy(code) + '"';
            } else {
               val =  '"' + getEconomy(val) + '"';
            }
         } else if (typeof val === 'string') {
            val = '"' + val + '"';
         } else if (typeof val === 'number') {
            if (decimalPoint !== '.') {
               val = val.toString().replace('.', decimalPoint);
            }
         }
         row[j] = val;
      }
      // Add the values
      csv += row.join(itemDelimiter);
      // Add the line delimiter
      csv += lineDelimiter;
   });

   if (this.options.csv) {
      var footer = this.options.csv.footer;
      if (!footer) {
         footer = [];
         if (this.options.csv.title) footer.push('<%=title%>');
         if (this.options.csv.source) footer.push('<%=source%>');
         if (this.options.csv.date) footer.push('Last updated: <%=date%>');
      }
      if (footer) csv += toCSVcomments(footer, bindings);
   }
   return csv;
});